/* eslint-disable */
const convertImgToDataURLviaCanvas = function (url, callback) {
  var img = new Image()
  img.crossOrigin = 'Anonymous'
  img.onload = function() {
    var canvas = document.createElement('CANVAS')
    var ctx = canvas.getContext('2d')
    var dataURL
    canvas.height = this.height
    canvas.width = this.width
    ctx.drawImage(this, 0, 0)
    dataURL = canvas.toDataURL()
    callback(dataURL)
    canvas = null
  }
  img.src = url
}

const dataURLtoBlob = function (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {type: mime})
}

const downloadAsset = function (imageDataAsset, productName) {
  var link = document.createElement('a')
  var blob = dataURLtoBlob(imageDataAsset)
  var objurl = URL.createObjectURL(blob)

  link.download = productName
  link.href = objurl

  link.click()
}

module.exports = {
  convertImgToDataURLviaCanvas,
  dataURLtoBlob,
  downloadAsset
}



// WEBPACK FOOTER //
// ./uncommon-client/utilities/ImgToB64.js